const inputWrappers = document.querySelectorAll('[js-form-file-element]');
if (inputWrappers.length) {
    inputWrappers.forEach(wrapper => {
        const fileLabel = wrapper.querySelector('[js-file-label]');
        wrapper.addEventListener('change', e => {
            const files = e.target.files;
            if (files.length) {
                const filesString = Array.from(files)
                    .map(file => file.name)
                    .join(', ');
                fileLabel.textContent = filesString;
            } else {
                fileLabel.textContent = wrapper.dataset.placeholder;
            }
        });
    });
}
